import PropTypes from 'prop-types'

import {Map} from 'immutable'
import {useEffect} from 'react'

import {setViewedFlagV2} from '../../../../lib/userTools'

import image from '../../../../dashboard/assets/no-deputies.svg'

import './noDeputiesModule.scss'

const NoDeputiesModule = props => {
  useEffect(() => {
    setViewedFlagV2({
      user: props.currentUser,
      flagToSet: 'first_visit_to_after_death_screen',
      updateResource: props.updateResource
    })
  }, [])

  return (
    <div className='no-deputies-module'>
      <img alt='' className='no-deputies-module__image' src={image} />
      <div className='no-deputies-module__content'>
        <div className='no-deputies-module__info'>
          <h3 className='no-deputies-module__section-title'>What is a Deputy?</h3>
          <p className='no-deputies-module__section_info'>
            A Deputy is someone you trust to access parts or all of your
            Everplan. You decide what they can see, and whether they can see it
            now or after you pass away.
          </p>
          <h3 className='no-deputies-module__section-title'>Who should I choose?</h3>
          <p className='no-deputies-module__section_info'>
            Consider someone such as:
          </p>
          <ul className='no-deputies-module__list'>
            <li className='no-deputies-module__list-item'>Your spouse or partner</li>
            <li className='no-deputies-module__list-item'>Adult children</li>
            <li className='no-deputies-module__list-item'>
              The executor of your Will
            </li>
            <li className='no-deputies-module__list-item'>Your Power of Attorney</li>
            <li className='no-deputies-module__list-item'>Trusted advisor</li>
          </ul>
          <h3 className='no-deputies-module__section-title'>
            How do Deputies gain access?
          </h3>
          <p className='no-deputies-module__section_info'>
            Deputies will receive an email invite to create a free account. They
            can immediately view any sections you choose to share now. If you
            choose “after death” for any section, we’ll ask you to select at
            least one person who can unlock these items.
          </p>
        </div>
      </div>
    </div>
  )
}

NoDeputiesModule.propTypes = {
  currentUser: PropTypes.instanceOf(Map),
  updateResource: PropTypes.func
}

export default NoDeputiesModule
